import { h } from 'preact';

export function ZohoForm({ firstName, lastName, email }) {
    const src = `https://forms.zohopublic.eu/ilerna/form/Soportealumnos/formperma/1ZxE_zX9BKOQWsKps_2WXT8Y7CHz6IZKGqrKkiSZvU8?first_name=${encodeURIComponent(firstName)}&last_name=${encodeURIComponent(lastName)}&email=${encodeURIComponent(email)}`;

    return (
        <iframe
            aria-label="Soporte alumnos"
            src={src}
            style={{
                height: "100%",
                width: "100%"
            }}
            frameBorder="0"
            title="Formulario de soporte"
        />
    );
}
